import ComponentElement from 'components/component-element';

function Step(modal, $element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.modal = modal;
    this.canPrevStep = true;
}

Step.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Step.prototype, 'constructor', {
    value: Step,
    enumerable: false,
    writable: true,
});

/**
 * Вызывается при показе
 */
Step.prototype.show = function() {
    this.modal.setCanPrevStep(true);
}

/**
 * Вызывается при скрытии
 */
Step.prototype.hide = function() {

}

/**
 * Показ шага
 * @param  {Step} step
 * @return {Step}
 */
Step.prototype.showStep = function(step) {
    return this.modal.showStep(step);
}

/**
 * Вызывается при шаге назад
 */
Step.prototype.back = function() {

}

export default Step;
